<mat-nav-list>
   <mat-list-item *ngFor="let item of menuItems" routerLink={{item.link}}>
     <i class="fa" ngClass={{item.icon}}></i>
     <div class="mat-nav-list-text">{{ item.name | translate}}</div>
   </mat-list-item>
</mat-nav-list>
